import { getLastInUseDetails } from './utils';
import { ReservationData } from '@/api/apis/resources';

type DevicaLastInUseProps = {
  lastInUseDaysAgo: number;
  reservations: ReservationData[];
};

export const DeviceLastInUse = ({ lastInUseDaysAgo, reservations }: DevicaLastInUseProps) => {
  return (
    <div className="flex flex-col">
      <div className="text-m-r">{`${lastInUseDaysAgo} day${lastInUseDaysAgo === 1 ? '' : 's'}`}</div>
      <div className="text-s-r text-base-20">{getLastInUseDetails(reservations)}</div>
    </div>
  );
};
